import React, { useState, useEffect } from "react";
import Select from "react-select";
import { API_GET_ASSIGNED_SYSTEMS_BY_EMPID } from "../../../config/Endpoints";
import { getApi } from "../../../utils/api";
import Cookies from "js-cookie";
import { ThreeDots } from "react-loader-spinner";
import SortableTable from "../../../components/SortableTable";
import Pagination from "../../../components/Pagination";

const AssignedSystems = ({
  employees,
  loadingEmployees,
  selectedEmployee,
  setSelectedEmployee,
}) => {
  const [assetList, setAssetList] = useState([]);

  const [isLoadingAssets, setIsLoadingAssets] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(10);
  const accessToken = Cookies.get("accessToken");

  // Table Columns
  const columns = [
    { key: "manufacture", label: "Manufacture" },
    {
      key: "assetName",
      label: "Asset Name",
      render: (row) => row.assestName,
    },
    { key: "serialNumber", label: "Serial Number" },
    { key: "owner", label: "Owner" },
  ];
  useEffect(() => {
    setCurrentPage(1);
  }, [selectedEmployee]);

  useEffect(() => {
    fetchAssets(selectedEmployee?.value, currentPage);
  }, [currentPage, limit, selectedEmployee]);

  const fetchAssets = async (employeeId = null, page = 1) => {
    setIsLoadingAssets(true);

    try {
      let url = `${API_GET_ASSIGNED_SYSTEMS_BY_EMPID}?page=${page - 1}&size=${limit}`;

      if (employeeId) {
        url += `&employeeId=${employeeId}`;
      }

      const res = await getApi(url, accessToken);

      if (res.status === 200) {
        setAssetList(res.data.content);
        setTotalPages(res.data.totalPages || 1);
      }
    } catch (error) {
      setAssetList([]);
    } finally {
      setIsLoadingAssets(false);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };
  const handleLimitChange = (e) => {
    setLimit(Number(e.target.value));
    setCurrentPage(1);
  };

  return (
    <>
      {/* Employee Dropdown */}
      <div className="filters d-flex justify-content-center align-items-center gap-2 mb-3 ">
        <div className="col-12 col-sm-8 col-md-6 col-lg-4">
          <label className="label">Employee Name</label>
          <Select
            className="pr"
            options={employees}
            placeholder="Select Employee Name"
            value={selectedEmployee}
            onChange={(opt) => setSelectedEmployee(opt)}
            isClearable
          />
        </div>
      </div>

      {/* Loader */}
      {isLoadingAssets && !loadingEmployees && (
        <div className="d-flex justify-content-center">
          <ThreeDots height="50" width="50" visible={true} color="blue" />
        </div>
      )}

      {/* No Data */}
      {!isLoadingAssets && selectedEmployee && assetList.length === 0 && (
        <div className="fs-5 text-secondary text-center">
          No records available
        </div>
      )}

      {/* Table */}
      {!isLoadingAssets && assetList.length > 0 && (
        <>
          <SortableTable
            columns={columns}
            data={assetList}
            currentPage={currentPage}
            limit={limit}
            className="resume custom"
          />
          <div className="row">
            <div className="col-md-3">
              <div>
                {/* Dropdown for selecting items per page */}
                <label htmlFor="itemsPerPage">Items per page </label>
                <select
                  id="itemsPerPage"
                  onChange={handleLimitChange}
                  value={limit}
                  className="border ms-3 w-25  p-2"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                  <option value={40}>40</option>
                </select>
              </div>
            </div>
            <div className="col-md-9">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AssignedSystems;
